module.exports = __webpack_public_path__ + "static/media/INDIGO.8b6a84e2.txt";